import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { POLICIES } from "../data/policies";
import SEO, { breadcrumbSchema } from "../components/SEO";
import Breadcrumb from "../components/Breadcrumb";

export default function PoliciesIndex() {
  const crumbs = [{ name: "Home", path: "/" }, { name: "Policies", path: "/policies" }];
  return (
    <div data-testid="page-policies">
      <SEO
        title="Policies · Oxford Environmental Consultants | Privacy, Quality, ISO, UK Legislation"
        description="Full set of Oxford Environmental Consultants policies: Privacy & GDPR, Terms of Service, Website Terms, Quality Policy, Complaints Procedure, UK Legislation reference, QMS Scope & ISO 9001 Certification (ISOQAR / UKAS-accredited) and Compliance & Improvement."
        path="/policies"
        schema={breadcrumbSchema(crumbs)}
      />
      <section className="bg-[#0A0F1C] text-white pt-16 pb-20 lg:pt-24 lg:pb-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="mb-8"><Breadcrumb items={crumbs} theme="dark" /></div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-6">Policies</p>
          <h1 className="font-display text-5xl lg:text-7xl font-bold tracking-tight max-w-4xl leading-[1.05]">Our policies &amp; governance.</h1>
          <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed">The full set of Oxford Environmental Consultants policies — each aligned to current UK legislation, ISO standards and the guidance of the relevant regulatory body.</p>
        </div>
      </section>
      <section className="bg-white py-16 lg:py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
            {POLICIES.map((p) => (
              <Link key={p.slug} to={p.slug === "environmental-plan" ? "/environmental-plan" : p.slug === "terms-of-service" ? "/termsofservice" : `/policies/${p.slug}`} className="group bg-white p-8 hover:bg-[#0A0F1C] hover:text-white transition-colors" data-testid={`policy-card-${p.slug}`}>
                <div className="flex items-start justify-between mb-6">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-slate-500 group-hover:text-white/50">{p.category}</p>
                  <ArrowUpRight className="w-4 h-4 text-slate-300 group-hover:text-white transition-colors" />
                </div>
                <h2 className="font-display text-xl font-semibold mb-3" dangerouslySetInnerHTML={{ __html: p.shortTitle }} />
                <p className="text-sm text-slate-600 group-hover:text-white/70 leading-relaxed">{p.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
